import React, { useState } from 'react';
import { dmClient } from '../services/dmClient';
import { useAuth } from '../auth/AuthContext';
import './admin/admin.css';

export default function AccountPage() {
  const { user } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setNotice('');
    if (form.newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (form.newPassword !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSaving(true);
    try {
      await dmClient.post('/auth/change-password', {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      setNotice('Password updated.');
      setForm({ currentPassword: '', newPassword: '', confirm: '' });
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Failed to change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-head">
        <div>
          <h1>Account</h1>
          <p>Your profile and password.</p>
        </div>
      </div>

      <div className="admin-card">
        <h3>Profile</h3>
        <dl className="admin-dl">
          <div><dt>Name</dt><dd>{user?.displayName || '—'}</dd></div>
          <div><dt>Email</dt><dd>{user?.email}</dd></div>
          <div><dt>Organization</dt><dd>{user?.orgName || user?.orgId}</dd></div>
          <div><dt>Roles</dt><dd>{(user?.roles || []).join(', ') || '—'}</dd></div>
        </dl>
      </div>

      <form className="admin-card admin-invite" onSubmit={submit} style={{ maxWidth: 460 }}>
        <h3>Change password</h3>
        {error && <div className="admin-alert admin-alert--error">{error}</div>}
        {notice && <div className="admin-alert admin-alert--ok">{notice}</div>}
        <label className="admin-stack">
          <span>Current password</span>
          <input type="password" value={form.currentPassword} required
                 onChange={(e) => setForm((v) => ({ ...v, currentPassword: e.target.value }))} />
        </label>
        <label className="admin-stack">
          <span>New password</span>
          <input type="password" value={form.newPassword} required
                 onChange={(e) => setForm((v) => ({ ...v, newPassword: e.target.value }))} />
        </label>
        <label className="admin-stack">
          <span>Confirm new password</span>
          <input type="password" value={form.confirm} required
                 onChange={(e) => setForm((v) => ({ ...v, confirm: e.target.value }))} />
        </label>
        <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
          {saving ? 'Saving…' : 'Update password'}
        </button>
      </form>
    </div>
  );
}
